import { useContext } from "react";
import { quoteContext } from "../../context/quotesContext";
import { useTranslation } from "react-i18next";

const SummarOrderSide = ({}) => {
  const [t] = useTranslation();
  const { selectedProvider, createShipmentResponse } = useContext(quoteContext);

  return (
    <div className="shipping-cost-container">
        {/*{!selectedProvider?.estimated_days && (<div className="warning-remitente">Ingresa un remitente para calcular</div>)}*/}
      <h2>{t('cost_of_shiping')}</h2>
      <div className="shipping-item">
        {t('freight')}
        <span>$ {selectedProvider.total_freight}</span>
      </div>
      <div className="shipping-item">
        {t('insurance_and_taxes')}
        <span>$ {selectedProvider.total_taxes_fees}</span>
      </div>
      <div className="shipping-item">
        {t('destination')}
        <span>{createShipmentResponse.city_to}</span>
      </div>
      <div className="shipping-item">
        {t('delivery_time')}
        <span>{selectedProvider.estimated_days} {Number(selectedProvider.estimated_days) >0 ? t('days'):t('day')}</span>
      </div>
      <div className="split-divide"></div>
      <div className="shipping-item total">
        {t('Total')}
        <span>${selectedProvider.total}</span>
      </div>
    </div>
  );
};

export { SummarOrderSide };
